module.exports = __webpack_public_path__ + "static/media/ARM_up_01.6cf3d449.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/arm/ARM_up_01.png
// module id = 287
// module chunks = 0